import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class AppStore {
    constructor() {
        this.alreadyLoadedBimModule = false;
        this.showGlobalSpinner$ = new BehaviorSubject(null);
    }
    setGlobalSpinnerIfLoadingBimModule(text) {
        if (!this.alreadyLoadedBimModule) {
            this.showGlobalSpinner$.next(text);
        }
    }
    setBimModuleLoaded() {
        this.alreadyLoadedBimModule = true;
    }
    dismissGlobalSpinner() {
        this.showGlobalSpinner$.next(null);
    }
    getGlobalSpinner() {
        return this.showGlobalSpinner$.asObservable();
    }
}
AppStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppStore_Factory() { return new AppStore(); }, token: AppStore, providedIn: "root" });
